import React from 'react'
import { useTranslation } from 'next-i18next'
import styles from './CountrySelect.module.scss'
import { Loader, CountrySelector, CustomText, CustomTitle } from 'src/components'

interface CountrySelectForRegisterProps {
  loading: boolean,
  showLabel?: boolean
}

const CountrySelectForRegister: React.FC<CountrySelectForRegisterProps> = (props) => {
  const { loading, showLabel = false } = props
  const { t } = useTranslation()

  return (
    <div >
      {loading ? <Loader /> : <>
        <CustomTitle label={t('admin.Brokerage.Country')} className={styles['label-text']} />
        {showLabel &&  <CustomText label={t('Auth.Register.CountryLabel')} type='secondary'/>}

        <CountrySelector
          name='country'
          placeholder={t('admin.Brokerage.CountryPlaceHolder')}
          required
        /></>
      }
    </div>
  )
}

export default CountrySelectForRegister
